/**
 * AP Invoices Demo — registry entries.
 *
 * THROWAWAY DEMO CODE. Side-effecting registration (imported once from
 * `@/demo/init`): registers the demo with the shared controls/provider registry
 * and the oRPC client-link resolver.
 */

import { registerDemo } from '@/demo/core/demo-registry';
import { registerDemoClientResolver } from '@/demo/core/demo-client';
import { AP_DEMO_KEY } from './demo-mode';
import { apDemoStore } from './fixture-store';
import { apDemoResolver } from './resolver';

registerDemo({
  key: AP_DEMO_KEY,
  label: 'AP Demo Mode',
  accent: {
    badge: 'border-emerald-200',
    label: 'text-emerald-700',
    resetButton: 'bg-emerald-600 hover:bg-emerald-700',
  },
  reset: () => {
    apDemoStore.reset();
  },
  StoreProvider: apDemoStore.StoreProvider,
});

registerDemoClientResolver(AP_DEMO_KEY, apDemoResolver);
